import { render, staticRenderFns } from "./ModalOrgaosParticipantes.vue?vue&type=template&id=cf320458&scoped=true"
import script from "./ModalOrgaosParticipantes.vue?vue&type=script&lang=js"
export * from "./ModalOrgaosParticipantes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf320458",
  null
  
)

export default component.exports